import ApiRequest from '../../utils/ApiRequest';
import { EnrollmentPackageId } from '../../types/api/primaryKeys/PrimaryKey';
import { PackageMessageContent } from '../../types/api/enrollmentContent/PackageMessageContent';

export async function getWelcomeContentForPackage(packageId: EnrollmentPackageId) {
    const result = await ApiRequest.get<PackageMessageContent>(`packages/${packageId}/welcome`);
    return result;
}

export async function getFinishContentForPackage(packageId: EnrollmentPackageId) {
    const result = await ApiRequest.get<PackageMessageContent>(`packages/${packageId}/finish`);
    return result;
}

export async function getTermsAcknowledgmentContentForPackage(packageId: EnrollmentPackageId) {
    const result = await ApiRequest.get<PackageMessageContent>(`packages/${packageId}/terms-acknowledgment`);
    return result;
}